import React from 'react'
import {Box, Text, List, ListItem} from '@salesforce/retail-react-app/app/components/shared/ui'
import {UnorderedList} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'

export const GiftCallout = () => (
    <Box bg="alternativeWarning.100" color="warningText" p={4} fontSize="sm">
        <Text fontWeight="bold">
            <FormattedMessage id="gift_callout.note.label" defaultMessage="Note:" />
        </Text>
        <UnorderedList pl={2}>
            <ListItem>
                <FormattedMessage
                    id="gift_callout.note.uk_only"
                    defaultMessage="This voucher can only be used in the <bold>United Kingdom</bold> in <bold>£ GBP</bold>."
                    values={{
                        bold: (chunks) => (
                            <Text as="span" fontWeight="bold">
                                {chunks}
                            </Text>
                        )
                    }}
                />
            </ListItem>
            <ListItem>
                <FormattedMessage
                    id="gift_callout.note.klarna_ineligible"
                    defaultMessage="Gift cards are not eligible for checkout with Klarna."
                />
            </ListItem>
            <ListItem>
                <FormattedMessage
                    id="gift_callout.note.final_sale"
                    defaultMessage="This item is <bold>final sale</bold> and not eligible for points."
                    values={{
                        bold: (chunks) => (
                            <Text as="span" fontWeight="bold">
                                {chunks}
                            </Text>
                        )
                    }}
                />
            </ListItem>
            <ListItem>
                <FormattedMessage
                    id="gift_callout.note.cancellation_waiver"
                    defaultMessage="By purchasing an e-voucher, you are consenting to immediate delivery and acknowledge that you are waiving your right to cancellation. Your statutory rights are not affected."
                />
            </ListItem>
        </UnorderedList>
    </Box>
)
